import React from "react";
import styles from "../../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyReadinessFlaggedPreview() {
  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum}`}>3</span>
        Flagged Non-Conformances &amp; Corrective Actions
      </div>
      <div className={styles.PreviewSectionBody} style={{ minHeight: "auto" }}>
        <table className={styles.PreviewTable}>
          <tbody>
            <tr>
              <td colSpan={2}>
                <span className={styles.PreStartQuestionGuidance} style={{ fontSize: "12px" }}>
                  No non-conformances flagged during this readiness checklist.
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
